module.exports = __webpack_public_path__ + "img/TempleGuardian.168d89e4.webp";